import React, { useState, useEffect } from "react";
import { Snowflake, Thermometer, CookingPot, CheckCircle, CaretLeft, CaretRight, X } from "@phosphor-icons/react";

const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "522282425769";
const MSG_REFRIGERACION = process.env.REACT_APP_WHATSAPP_MSG_REF || "Hola CTEX, necesito informes sobre Mantenimiento en Refrigeración.";
const MSG_CLIMATIZACION = process.env.REACT_APP_WHATSAPP_MSG_CLIM || "Hola CTEX, solicito informes para Aire Acondicionado / Climatización.";
const MSG_COCCION = process.env.REACT_APP_WHATSAPP_MSG_COCC || "Hola CTEX, necesito soporte para equipos de Cocción Comercial.";

const services = [
    {
        id: "refrigeracion",
        title: "Refrigeración Comercial e Industrial",
        description: "Cámaras frías, cuartos de congelación y sistemas de conservación.",
        Icon: Snowflake,
        whatsappMsg: MSG_REFRIGERACION,
        images: [
            { url: "/img/refrigeracion-comercial/RI11.webp", desc: "Instalación de unidad condensadora para cámara frigorífica." },
            { url: "/img/refrigeracion-comercial/RI12.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI1.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI2.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI3.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI4.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI5.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI6.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI7.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI8.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI9.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI10.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-13.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-14.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-15.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-16.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-17.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-18.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-19.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-20.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-21.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-22.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-23.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-24.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-25.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-26.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-27.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-28.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-29.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-30.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-31.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-32.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-33.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-34.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-35.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-36.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-37.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-38.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-39.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-40.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-41.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-42.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-43.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-44.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-45.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-46.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-47.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-48.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-49.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-50.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-51.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-52.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-53.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-54.webp", desc: "" },
            { url: "/img/refrigeracion-comercial/RI-55.webp", desc: "" },
        ],
    },
    {
        id: "climatizacion",
        title: "Aire Acondicionado y Climatización",
        description: "Sistemas tipo paquete, VRF/VRV y unidades de precisión para empresas.",
        Icon: Thermometer,
        whatsappMsg: MSG_CLIMATIZACION,
        images: [
            { url: "/img/aire-acondicionado/AA0.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA1.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA2.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA3.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA4.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA5.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA6.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA7.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA8.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA9.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA10.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA11.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA12.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA13.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA14.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA15.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA16.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA17.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA18.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA19.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA20.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA21.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA22.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA23.webp", desc: "" },
            { url: "/img/aire-acondicionado/AA24.webp", desc: "" },

        ],
    },
    {
        id: "coccion",
        title: "Cocción Comercial",
        description: "Hornos industriales, estufas y freidoras de alta capacidad.",
        Icon: CookingPot,
        whatsappMsg: MSG_COCCION,
        images: [
            { url: "/img/coccion-comercial/CM28.webp", desc: "" },
            { url: "/img/coccion-comercial/CM1.webp", desc: "" },
            { url: "/img/coccion-comercial/CM2.webp", desc: "" },
            { url: "/img/coccion-comercial/CM3.webp", desc: "" },
            { url: "/img/coccion-comercial/CM4.webp", desc: "" },
            { url: "/img/coccion-comercial/CM5.webp", desc: "" },
            { url: "/img/coccion-comercial/CM6.webp", desc: "" },
            { url: "/img/coccion-comercial/CM7.webp", desc: "" },
            { url: "/img/coccion-comercial/CM8.webp", desc: "" },
            { url: "/img/coccion-comercial/CM9.webp", desc: "" },
            { url: "/img/coccion-comercial/CM10.webp", desc: "" },
            { url: "/img/coccion-comercial/CM11.webp", desc: "" },
            { url: "/img/coccion-comercial/CM12.webp", desc: "" },
            { url: "/img/coccion-comercial/CM13.webp", desc: "" },
            { url: "/img/coccion-comercial/CM14.webp", desc: "" },
            { url: "/img/coccion-comercial/CM15.webp", desc: "" },
            { url: "/img/coccion-comercial/CM16.webp", desc: "" },
            { url: "/img/coccion-comercial/CM17.webp", desc: "" },
            { url: "/img/coccion-comercial/CM18.webp", desc: "" },
            { url: "/img/coccion-comercial/CM19.webp", desc: "" },
            { url: "/img/coccion-comercial/CM20.webp", desc: "" },
            { url: "/img/coccion-comercial/CM21.webp", desc: "" },
            { url: "/img/coccion-comercial/CM22.webp", desc: "" },
            { url: "/img/coccion-comercial/CM23.webp", desc: "" },
            { url: "/img/coccion-comercial/CM24.webp", desc: "" },
            { url: "/img/coccion-comercial/CM25.webp", desc: "" },
            { url: "/img/coccion-comercial/CM26.webp", desc: "" },
            { url: "/img/coccion-comercial/CM27.webp", desc: "" },
            { url: "/img/coccion-comercial/CM29.webp", desc: "" },
            { url: "/img/coccion-comercial/CM30.webp", desc: "" },
            { url: "/img/coccion-comercial/CM31.webp", desc: "" },
            { url: "/img/coccion-comercial/CM32.webp", desc: "" },

        ],
    }
];

const ImageCarousel = ({ images, title, onImageClick }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const carouselDuration = 7000;

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % images.length);
        }, carouselDuration);
        return () => clearInterval(timer);
    }, [images.length]);

    return (
        <div
            className="relative overflow-hidden rounded-2xl shadow-2xl group cursor-zoom-in h-64 md:h-80"
            onClick={() => onImageClick(images, currentIndex)}
        >
            {images.map((img, i) => (
                <img
                    key={i}
                    src={img.url}
                    alt={`${title} - ${i}`}
                    loading="lazy"
                    className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-[2000ms] ${
                        i === currentIndex ? "opacity-100" : "opacity-0"
                    }`}
                />
            ))}
            <div className="absolute inset-0 bg-black/10 group-hover:bg-black/0 transition-colors" />

            <div className="absolute bottom-4 right-4 bg-black/60 backdrop-blur-sm text-white text-[10px] font-black px-3 py-1.5 rounded-full border border-white/20 shadow-xl z-20">
                {currentIndex + 1} / {images.length}
            </div>

            <div
                className="absolute bottom-0 left-0 h-1 bg-ctex-orange transition-all ease-linear"
                style={{
                    width: `${((currentIndex + 1) / images.length) * 100}%`,
                    transitionDuration: `${carouselDuration}ms`
                }}
            />
        </div>
    );
};

const HomeServices = () => {
    const [lightbox, setLightbox] = useState({ isOpen: false, images: [], index: 0 });

    const openLightbox = (images, index) => {
        setLightbox({ isOpen: true, images, index });
    };

    const closeLightbox = () => {
        setLightbox({ ...lightbox, isOpen: false });
    };

    const nextImage = (e) => {
        e.stopPropagation();
        setLightbox(prev => ({
            ...prev,
            index: (prev.index + 1) % prev.images.length
        }));
    };

    const prevImage = (e) => {
        e.stopPropagation();
        setLightbox(prev => ({
            ...prev,
            index: (prev.index - 1 + prev.images.length) % prev.images.length
        }));
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (!lightbox.isOpen) return;
            if (e.key === "ArrowRight") nextImage(e);
            if (e.key === "ArrowLeft") prevImage(e);
            if (e.key === "Escape") closeLightbox();
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [lightbox.isOpen, lightbox.index]);

    return (
        <section id="servicios" className="py-20 bg-gray-50">
            <div className="container mx-auto px-4">
                <div className="text-center max-w-3xl mx-auto mb-16">
                    <h2 className="text-4xl font-bold text-ctex-blue mb-4 uppercase tracking-tighter italic">
                        Mantenimiento Especializado
                    </h2>
                    <p className="text-gray-600 text-lg">
                        Prevención y corrección para asegurar la continuidad de su negocio.
                    </p>
                </div>

                <div className="space-y-24">
                    {services.map((service, index) => {
                        const ServiceIcon = service.Icon;
                        return (
                            <div key={service.id} className={`flex flex-col md:flex-row items-center gap-12 ${index % 2 !== 0 ? "md:flex-row-reverse" : ""}`}>
                                <div className="w-full md:w-1/2">
                                    <ImageCarousel
                                        images={service.images}
                                        title={service.title}
                                        onImageClick={openLightbox}
                                    />
                                </div>
                                <div className="w-full md:w-1/2">
                                    <div className="inline-flex p-3 rounded-xl bg-ctex-orange/10 mb-6 text-ctex-orange">
                                        <ServiceIcon size={32} weight="duotone" />
                                    </div>
                                    <h3 className="text-3xl font-bold text-gray-900 mb-4 uppercase tracking-tight">{service.title}</h3>
                                    <p className="text-gray-600 text-lg mb-8 leading-relaxed">{service.description}</p>
                                    <a
                                        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(service.whatsappMsg)}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="inline-flex items-center gap-3 bg-ctex-blue hover:bg-blue-900 text-white font-bold py-3 px-8 rounded-full transition-all shadow-lg active:scale-95"
                                    >
                                        Solicitar Soporte Técnico
                                        <CheckCircle size={22} />
                                    </a>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {lightbox.isOpen && (
                <div
                    className="fixed inset-0 z-[200] bg-black/95 flex items-center justify-center p-4"
                    onClick={closeLightbox}
                >
                    <button className="absolute top-6 right-6 text-white hover:text-ctex-orange transition-colors z-[210]">
                        <X size={40} />
                    </button>

                    <button className="absolute left-4 text-white bg-white/10 hover:bg-white/20 p-4 rounded-full transition-all z-[210]" onClick={prevImage}>
                        <CaretLeft size={32} weight="bold" />
                    </button>

                    <div className="relative max-w-5xl w-full flex flex-col items-center">
                        <img
                            src={lightbox.images[lightbox.index].url}
                            alt="Vista ampliada"
                            className="max-w-full max-h-[70vh] rounded-lg shadow-2xl object-contain animate-in fade-in zoom-in duration-300"
                            onClick={(e) => e.stopPropagation()}
                        />

                        <div className="mt-6 text-center max-w-2xl px-4 animate-in slide-in-from-bottom duration-500">
                            {lightbox.images[lightbox.index].desc && (
                                <p className="text-white text-lg md:text-xl font-medium mb-3 italic">
                                    {lightbox.images[lightbox.index].desc}
                                </p>
                            )}
                            <div className="inline-block bg-ctex-orange text-white text-xs font-black px-4 py-1 rounded-full uppercase tracking-widest">
                                Imagen {lightbox.index + 1} de {lightbox.images.length}
                            </div>
                        </div>
                    </div>

                    <button className="absolute right-4 text-white bg-white/10 hover:bg-white/20 p-4 rounded-full transition-all z-[210]" onClick={nextImage}>
                        <CaretRight size={32} weight="bold" />
                    </button>
                </div>
            )}
        </section>
    );
};

export default HomeServices;